const initialState = () => ({
  campaigns: [],
});

const state = initialState();

export default state;
